<ng-container *ngIf="context">
  <mat-tab-group [(selectedIndex)]="selectedSubTab" animationDuration="100ms" class="document-subtab-group">
    <mat-tab [label]="'nouns.exam-guide' | translate">
      <app-exams-guide [logId]="logId" [context]="context"> </app-exams-guide>
    </mat-tab>

    <mat-tab [label]="'nouns.referral-guide-tab' | translate">
      <app-referral-guide [logId]="logId" [context]="context"> </app-referral-guide>
    </mat-tab>
  </mat-tab-group>
</ng-container>
<div *ngIf="!context" class="loading-container">
  <mat-spinner diameter="50"></mat-spinner>
  <span class="loading-text">{{ "nouns.loading" | translate }}</span>
</div>
